<script>
import options from './LocationCard.options'
export default options
</script>

<template>
  <article class="kb-location-card__card">
    <a :href="result.url" :target="result.urlTarget" class="kb-location-card">
      <div class="kb-location-card__card__image-wrapper">
        <template v-if="result.svgIcon">
          <div
            class="kb-location-card__card__icon-box"
            :class="result.labelColorTheme"
          >
            <div
              class="kb-location-card__card__icon-wrapper"
              v-html="result.svgIcon"
            ></div>
            <p class="kb-location-card__card__icon-text">
              {{ result.iconText }}
            </p>
          </div>
        </template>
        <img :src="transformImage(result.imgUrl, locationCard_5_4)" alt="" />
      </div>

      <div class="kb-location-card__card__content-wrapper">
        <div class="kb-location-card__card__top">
          <p class="kb-location-card__card__small-title">
            {{ result.smallTitle }}
          </p>
          <h2 class="kb-location-card__card__title">{{ result.title }}</h2>
          <div
            class="kb-rich-text__content kb-rich-text__content--location-card"
          >
            <p>{{ result.location }}</p>
            <p>{{ result.street }}</p>
            <p>{{ result.city }}</p>
            <p class="kb-rich-text__content--location-card-info">
              {{ result.locationInfo }}
            </p>
          </div>
        </div>
      </div>
    </a>
    <div class="kb-location-card__card__content-wrapper">
      <div class="kb-location-card__card__bottom">
        <hr />
        <dl class="kb-location-card__card__contact-info">
          <dt>{{ result.phoneLabel }}</dt>
          <dd>{{ result.phoneNumber }}</dd>
          <dt>{{ result.emailLabel }}</dt>
          <dd>
            <a :href="'mailto:' + result.emailAddress">{{
              result.emailAddress
            }}</a>
          </dd>
          <dt>{{ result.daysOne }}</dt>
          <dd>{{ result.timeSlotOne }}</dd>
          <dt>{{ result.daysTwo }}</dt>
          <dd>{{ result.timeSlotTwo }}</dd>
        </dl>
      </div>
    </div>
  </article>
</template>
